import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12080b89"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "chart-container"
}
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "top" }
const _hoisted_4 = { class: "inside" }
const _hoisted_5 = { class: "voting-result" }
const _hoisted_6 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot yes" }, null, -1 /* HOISTED */))
const _hoisted_8 = { class: "bar-legend" }
const _hoisted_9 = { style: {"font-weight":"bold"} }
const _hoisted_10 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot abstain" }, null, -1 /* HOISTED */))
const _hoisted_12 = { class: "bar-legend" }
const _hoisted_13 = { style: {"font-weight":"bold"} }
const _hoisted_14 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot no" }, null, -1 /* HOISTED */))
const _hoisted_16 = { class: "bar-legend" }
const _hoisted_17 = { style: {"font-weight":"bold"} }
const _hoisted_18 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot no-with-veto" }, null, -1 /* HOISTED */))
const _hoisted_20 = { class: "bar-legend" }
const _hoisted_21 = { style: {"font-weight":"bold"} }
const _hoisted_22 = { class: "bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return ($props.proposal && $setup.option !== false)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString($setup.props.proposalDetailsTally) + " ", 1 /* TEXT */),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("GOVERNANCE_VIEW.TOTAL_VOTED")) + " / " + _toDisplayString(_ctx.$t("GOVERNANCE_VIEW.TOTAL")), 1 /* TEXT */),
          _createElementVNode("span", null, [
            _createCommentVNode("        <CoinAmount :amount=\"useProposalsStore().getSelectedProposalTally.total\" :reduce-big-number=\"true\" :precision=\"2\"/> /"),
            _createVNode($setup["CoinAmount"], {
              amount: $setup.wrapBigInt($setup.totalVotes),
              "reduce-big-number": true,
              precision: 2
            }, null, 8 /* PROPS */, ["amount"]),
            _createTextVNode(" / "),
            _createVNode($setup["CoinAmount"], {
              amount: $setup.wrapBigInt($setup.bondedTokens),
              "reduce-big-number": true,
              precision: 2
            }, null, 8 /* PROPS */, ["amount"])
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("GOVERNANCE_VIEW.CURRENT_TURNOUT")), 1 /* TEXT */),
          _createElementVNode("span", null, _toDisplayString($setup.calculatePercents(Number($setup.totalVotes), Number($setup.bondedTokens), 2)) + "% ", 1 /* TEXT */)
        ]),
        _createVNode($setup["ShadowedSvgChart"], {
          id: "voteschartdiv",
          class: "chartdiv"
        }, {
          default: _withCtx(() => [
            _createVNode($setup["VChart"], {
              option: $setup.option,
              autoresize: ""
            }, null, 8 /* PROPS */, ["option"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode($setup["Icon"], {
                name: $setup.icons.get($setup.getProposalStatus())
              }, null, 8 /* PROPS */, ["name"]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("GOVERNANCE_VIEW."+$setup.getProposalStatus())), 1 /* TEXT */)
            ])
          ]),
          _: 1 /* STABLE */
        }),
        _createCommentVNode("    <ProgressBarComponent v-if=\"getProposalStatus()===ProposalStatus.VOTING_PERIOD\" ref=\"childRef\" @refresh=\"updateVotes\" :loading-time=\"useConfigurationStore().getConfig.proposalVotingRefreshTimeout\" style=\"width: 100%\"></ProgressBarComponent>"),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("GOVERNANCE_VIEW.VOTING_OPTIONS.YES")), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_9, [
                _createVNode($setup["PercentsView"], {
                  amount: $setup.yesPercentage,
                  precision: 2
                }, null, 8 /* PROPS */, ["amount"])
              ]),
              _createCommentVNode("          (<CoinAmount :amount=\"useProposalsStore().getSelectedProposalTally.yes\" :reduce-big-number=\"true\" :precision=\"2\"/>)"),
              _createTextVNode(" ("),
              _createVNode($setup["CoinAmount"], {
                amount: $setup.wrapBigInt($setup.yes),
                "reduce-big-number": true,
                precision: 2
              }, null, 8 /* PROPS */, ["amount"]),
              _createTextVNode(") ")
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("GOVERNANCE_VIEW.VOTING_OPTIONS.ABSTAIN")), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_13, [
                _createVNode($setup["PercentsView"], {
                  amount: $setup.abstainPercentage,
                  precision: 2
                }, null, 8 /* PROPS */, ["amount"])
              ]),
              _createCommentVNode("          (<CoinAmount :amount=\"useProposalsStore().getSelectedProposalTally.abstain\" :reduce-big-number=\"true\" :precision=\"2\"/>)"),
              _createTextVNode(" ("),
              _createVNode($setup["CoinAmount"], {
                amount: $setup.wrapBigInt($setup.abstain),
                "reduce-big-number": true,
                precision: 2
              }, null, 8 /* PROPS */, ["amount"]),
              _createTextVNode(") ")
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("GOVERNANCE_VIEW.VOTING_OPTIONS.NO")), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_17, [
                _createVNode($setup["PercentsView"], {
                  amount: $setup.noPercentage,
                  precision: 2
                }, null, 8 /* PROPS */, ["amount"])
              ]),
              _createCommentVNode("          (<CoinAmount :amount=\"useProposalsStore().getSelectedProposalTally.no\" :reduce-big-number=\"true\" :precision=\"2\"/>)"),
              _createTextVNode(" ("),
              _createVNode($setup["CoinAmount"], {
                amount: $setup.wrapBigInt($setup.no),
                "reduce-big-number": true,
                precision: 2
              }, null, 8 /* PROPS */, ["amount"]),
              _createTextVNode(") ")
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("GOVERNANCE_VIEW.VOTING_OPTIONS.NO_WITH_VETO")), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_21, [
                _createVNode($setup["PercentsView"], {
                  amount: $setup.noWithVetoPercentage,
                  precision: 2
                }, null, 8 /* PROPS */, ["amount"])
              ]),
              _createCommentVNode("          (<CoinAmount :amount=\"useProposalsStore().getSelectedProposalTally.noWithVeto\" :reduce-big-number=\"true\" :precision=\"2\"/>)"),
              _createTextVNode(" ("),
              _createVNode($setup["CoinAmount"], {
                amount: $setup.wrapBigInt($setup.noWithVeto),
                "reduce-big-number": true,
                precision: 2
              }, null, 8 /* PROPS */, ["amount"]),
              _createTextVNode(") ")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_Button, {
            class: "p-button-raised p-button-rounded",
            "data-bs-toggle": "modal",
            "data-bs-target": "#voteModal",
            disabled: 
        $setup.useProposalsStore().getProposal?.status !== $setup.ProposalStatus.VOTING_PERIOD
          }, {
            default: _withCtx(() => [
              _createVNode($setup["GovernanceIcon"], { icon: "vote" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('GOVERNANCE_VIEW.VOTE')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled"]),
          _createVNode($setup["VoteModal"], {
            id: "voteModal",
            proposalId: $props.proposal.proposalId,
            title: $setup.getProposalTitle()
          }, null, 8 /* PROPS */, ["proposalId", "title"])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}